import * as angular from 'angular';

import {
    IWorkspaceService,
    ILoggerService,
    IApplicationService,
    ICurrentApplicationService,
    IWideDatabaseService,
    IRequestService
} from '../';

export interface IWideDatabaseUpdateService {
    update(guid: string): angular.IPromise<any>;
}

export class WideDatabaseUpdateService implements IWideDatabaseUpdateService {
    static serviceId: string = 'WideDatabaseUpdateService';
    static $inject = ['requestService', 'wideDatabaseService', 'loggerService', 'workspaceService', 'applicationService', 'currentApplicationService'];

    constructor(
        private _requestService: IRequestService,
        private _wideDatabaseService: IWideDatabaseService,
        private _loggerService: ILoggerService,
        private _workspaceService: IWorkspaceService,
        private _applicationService: IApplicationService,
        private _currentApplicationService: ICurrentApplicationService) {
    }

    update(guid: string): angular.IPromise<any> {
        return this._wideDatabaseService.migrateGivenDatabaseAsync(guid)
            .then(message => {
                this._loggerService.logSuccess(message, true);
                this._requestService.cleanAllCache();
                const workspace = this._workspaceService.getWorkspace();
                return this._applicationService.getByName(workspace.application);
            })
            .then(application => {
                this._currentApplicationService.setApplication(application);
            })
            .catch(reason => this._loggerService.logError(reason, true));
    }
}